module.exports = __webpack_public_path__ + "img/ИФ-1(А)-036.1484d135.png";